<template>
  <div class="my-2" style="">
    <div class="containerClass" :style="containerStyle">
      <img
        :src="fullImages['eye']"
        :style="eyeStyle"
        class="absClass"
        alt="Right Eye"
      />

      <v-expand-transition>
        <img
          v-if="correctiveLens"
          :src="fullImages['correctiveLens']"
          :style="correctiveLensStyle"
          class="absClass centerAll"
          alt="Corrective Lens"
        />
      </v-expand-transition>

      <light-rays
        class="absClass centerVert"
        :style="rightAtLens"
        :size="size * 0.735"
        :ray1Width="sphereRayWidth"
        :ray2Width="cylinderRayWidth"
        alt="light rays"
      ></light-rays>

      <div
        class="d-flex flex-row justify-center align-center width100p absClass"
        v-if="!hideAccom"
        style="left: 0; bottom: 0px"
      >
        <div class="caption mt-1">Accom:</div>
        <div style="position: relative" class="flex-grow-1">
          <!-- <v-progress-linear
            :value="scaledMaxAccom"
            color="#90CAF9"
            class="mx-1 absClass progressClass"
            height="6"
            rounded
            :style="`width:${size * 0.8}px;`"
          ></v-progress-linear> -->
          <v-progress-linear
            v-model="scaledAccommodation"
            color="blue"
            class="mx-1 absClass progressClass"
            height="6"
            rounded
            :style="`width:${size * 0.8}px;`"
          ></v-progress-linear>
        </div>
      </div>

      <img
        :src="fullImages['lens']"
        :style="lensStyle"
        class="absClass centerAll lensClass"
        alt="Lens"
      />
      <!-- <gauge
        class="absClass"
        :size="size / 3"
        style="left: 0; bottom: 0"
        :min="0"
        :max="4"
        :value="accommodation"
      ></gauge> -->
    </div>
  </div>
</template>

<script>
import LightRays from "./LightRays.vue";

export default {
  name: "VsEye",
  components: {
    // Gauge: () => import("./Gauge.vue"),
    LightRays,
  },
  props: {
    size: {
      type: Number,
      default: 400,
    },
    eye: {
      type: String,
      default: "od",
    },
    uncorrectedRx: null,
    hideRays: null,
    accommodation: { type: Number, default: 0 }, // in diopters
    maxAccom: { type: Number, default: 4 }, // in diopters
    sphere: { type: Number, default: 0 }, // a number in diopters
    cylinder: { type: Number, default: 0 }, // a number in diopters
    correctiveLens: null,
    hideAccom: null,
    // accomGauge: { type: Boolean, default: true },
    // flipVert: null, // flips the eye vertically
  },
  data: function () {
    return {
      imageRoot: "https://www.eyedock.com/images/visionSimulator/",
      images: {
        eye: "simpleEye.svg",
        lens: "lens.svg",
        frontRay: "frontRay.svg",
        // sphereRay: "sphereRay.svg",
        // cylinderRay: "cylRay.svg",
        // lens_plus: "lens_plus.svg",
        // lens_minus: "lens_minus.svg",
        correctiveLens: "correctiveLens.svg",
      },
      ratios: {
        left: 25, // percent from the left edge of the eye the lens
        lensHeight: 28, // percent of the eye height
        plano: 0.74, // ratio to make the ray1 focus on the retina at 50%
        // cylinderPlano: 0.73, // ratio to make the ray2 focus on the retina at 50%
        maxRayWidth: 0.45, // ratio of how long the rays should be relative to the eye size
      },
      scaledAccommodation: 0,
      scaledMaxAccom: 100,
      //   sphereRayPercent: 50,
      //   cylinderRayPercent: 50,
    };
  },
  methods: {
    powerToWidth: function (power) {
      let dir = power < 0 ? -1 : 1;

      let newVal = (Math.abs(power) * this.maxRayWidth) / 10;
      if (dir > 0) newVal = newVal * 1.25; // make the hyperopic rays a bit longer
      return newVal * dir;
    },
  },
  computed: {
    // perfectRayWidth: function () {
    //   return this.size * this.ratios.perfectRayWidth;
    // },
    rxSphere: function () {
      if (this.uncorrectedRx?.sph) return this.uncorrectedRx.sph;
      return this.sphere;
    },
    rxCylinder: function () {
      if (this.uncorrectedRx?.cyl) return this.uncorrectedRx.cyl;
      return this.cylinder;
    },

    maxRayWidth: function () {
      return this.size * this.ratios.maxRayWidth;
    },
    fullImages: function () {
      let rtn = {};
      for (let key in this.images) {
        rtn[key] =
          this.imageRoot +
          this.images[key] +
          "#svgView(preserveAspectRatio(none))";
      }
      return rtn;
    },
    containerStyle: function () {
      let rtn = "";
      rtn += `height: ${this.size}px; width: ${this.size}px; `;
      return rtn;
    },
    eyeStyle: function () {
      let rtn = "";
      rtn += `height: ${this.size}px; `;
      if (this.eye == "os") rtn += "transform: scaleY(-1); ";
      return rtn;
    },
    lensStyle: function () {
      let rtn = "";
      let accomWidth = this.powerToWidth(this.accommodation) * 1.3;
      rtn += `width: ${(this.size + accomWidth) / 5}px; `;
      rtn += `height: ${this.ratios.lensHeight}%; `;
      rtn += `left: ${this.ratios.left}%; `;
      return rtn;
    },
    correctiveLensStyle: function () {
      let isCL = this.correctiveLens == "cl";
      let rtn = "";
      let ht = isCL ? this.ratios.lensHeight * 1.5 : this.ratios.lensHeight * 2;
      let left = isCL ? 2 : -4;
      rtn += `height: ${ht}%; `;
      rtn += `left: ${left}%; `;
      return rtn;
    },

    planoWidth: function () {
      return this.size * this.ratios.plano;
    },
    // cylinderPlanoWidth: function () {
    //   return this.size * this.ratios.cylinderPlano;
    // },
    sphereRayWidth: function () {
      return this.planoWidth + this.powerToWidth(this.rxSphere);
    },
    cylinderRayWidth: function () {
      // console.log(this.rxSphere, this.rxCylinder);
      return (
        this.planoWidth + this.powerToWidth(this.rxSphere + this.rxCylinder)
      );
    },

    leftAtLens: function () {
      return `right: calc(${100 - this.ratios.left}% - 2px); `;
    },
    rightAtLens: function () {
      return `left: calc(${this.ratios.left}% - 2px) `;
    },
  },
  watch: {
    accommodation: function (val) {
      this.scaledAccommodation = val * 25;
    },
    maxAccom: function (val) {
      this.scaledMaxAccom = val * 25;
    },
  },
  mounted() {
    this.scaledAccommodation = this.accommodation * 25;
    this.scaledMaxAccom = this.maxAccom * 25;
  },
};
</script>

<style scoped>
.containerClass {
  position: relative;
  /*
	margin: 2em 6em;
*/
}
.absClass {
  position: absolute;
}
.centerAll {
  /*careful - if transform is specified on the element somewhere else, this will be overwritten*/
  transform: translate(-50%, -50%);
  top: 50%;
}
.centerVert {
  transform: translateY(-50%);
  top: 50%;
}
.topOfVertCenter {
  bottom: calc(50% - 0.5%);
}
.bottomOfVertCenter {
  top: calc(50% - 3%); /* the 5% is for the little part that sticks up ... */
}
.clipPath51 {
  clip-path: inset(51% 0px 0px 0px);
}
.clipPath49 {
  clip-path: inset(49% 0px 0px 0px);
}
.middleLine {
  height: 1px;
  background-color: #000000;
}
.lensClass {
  transition: 0.5s;
  opacity: 0.6;
}
.progressClass {
  position: absolute;
  top: 0;
  left: 0;
  height: 6px;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
</style>
